"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTaskFormFieldType = void 0;
/**
 * Determines the type of a UserTasks FormField.
 */
var UserTaskFormFieldType;
(function (UserTaskFormFieldType) {
    UserTaskFormFieldType["boolean"] = "boolean";
    UserTaskFormFieldType["date"] = "date";
    UserTaskFormFieldType["enum"] = "enum";
    UserTaskFormFieldType["long"] = "long";
    UserTaskFormFieldType["number"] = "number";
    UserTaskFormFieldType["string"] = "string";
})(UserTaskFormFieldType = exports.UserTaskFormFieldType || (exports.UserTaskFormFieldType = {}));
//# sourceMappingURL=UserTaskInstance.js.map